import PropTypes from 'prop-types';
import React from 'react';

import { Header, SideLine, Footer, Background } from '$partials/global/index.js';
import { Image } from '$partials/media';
import { ModuleDispatcher } from '$partials/modules';
import { getBackgroundColours } from '$utilities/site-context';
import { SelectedPressItem } from '$partials/listings';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const PersonPage = (props) => {

    const page = props.data.page;

    return (
        <>
            <Background {...getBackgroundColours()} />

            {/* Navigation */}
            <Header navigation={props.data.navigation}/>
            {/* Spacer */}
            <div className='pt-40 sm:pt-50 md:pt-80'></div>

            <main
                className='min-h-screen relative'
                id='main-content'>
                <SideLine />


                <div className='layout-container-padding-right flex flex-wrap max-w-container bg-white pt-60 sm:pt-70 md:pt-80 pb-50 sm:pb-40 md:pb-60 rounded-t-md'>
                    {/* Left Sidebar */}
                    <div className='w-sidebar'>
                    </div>

                    {/* Main content */}
                    <div className='flex-1 flex flex-wrap self-start layout-negative-margin'>
                        {/* First section */}
                        <section className='sm:flex w-full'>

                            <div className='sm:w-7/12 md:w-6/12 layout-item-padding'>
                                {/* Title */}
                                <h1 className='type-style-3 mb-20 sm:mb-15'>
                                    {page?.title}
                                </h1>

                                <h3 className='type-style-5'>
                                    {page?.jobTitle}
                                </h3>

                                {/* Share Links */}
                                <ul className='flex mt-15 type-style-5'>
                                    {page.linkedinUrl && (
                                        <>
                                            <li className=''>
                                                <a
                                                    className=''
                                                    href={page.linkedinUrl}
                                                    rel='noreferrer noopener'
                                                    target='_blank'>
                                                    {'LinkedIn'}
                                                </a>
                                                {page?.twitterUrl && (
                                                    <span>&nbsp;·&nbsp;</span>
                                                )}
                                            </li>
                                        </>
                                    )}
                                    {page.twitterUrl && (
                                        <>
                                            <li className=''>
                                                <a
                                                    className=''
                                                    href={page.twitterUrl}
                                                    rel='noreferrer noopener'
                                                    target='_blank'>
                                                    {'X'}
                                                </a>
                                            </li>
                                        </>
                                    )}
                                </ul>

                                <div className='md:w-4/6'>
                                    {(page?.image || page?.listingImage) && (
                                        <Image
                                            containerClassName='rounded-lg mt-30 md:mt-40'
                                            {...(page.image || page.listingImage)} />
                                    )}
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                {/* Module dispatcher */}
                {page.modules?.length > 0 &&
                    <section className='person-modules'>
                        {page.modules.map((module, i, { length, ...modules }) => {
                            const isLast = length - 1 === i;
                            const nextModuleType = modules[i + 1]?.__typename;
                            const previousModuleType = modules[i - 1]?.__typename;
                            return (
                                <ModuleDispatcher
                                    {...module}
                                    isLast={isLast}
                                    key={i + module?.id}
                                    nextModuleType={nextModuleType}
                                    pageTypename={page.__typename}
                                    previousModuleType={previousModuleType}/>
                            );
                        })}
                    </section>
                }

                {page.selectedPress?.length > 0 &&
                    <section className='module module-external-links'>
                        <SelectedPressItem
                            borderBottom={true}
                            borderTop={false}
                            items={page.selectedPress} />
                    </section>
                }
            </main>

            {/* Footer */}
            {props.data?.footer && (
                <Footer {...props.data.footer}/>
            )}
        </>
    );
};


/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.shape({
            __typename: PropTypes.string,
            image: PropTypes.object,
            listingImage: PropTypes.object,
            jobTitle: PropTypes.string,
            linkedinUrl: PropTypes.string,
            title: PropTypes.string,
            twitterUrl: PropTypes.string,
            modules: PropTypes.arrayOf(PropTypes.object,),
            funds: PropTypes.shape({
                edges: PropTypes.arrayOf(PropTypes.shape({
                    node: PropTypes.shape({
                        url: PropTypes.string,
                        title: PropTypes.string,
                        branding: PropTypes.string,
                    }),
                }),),
            }),
            selectedPress: PropTypes.array,
        }),
        navigation: PropTypes.object,
        footer: PropTypes.object,
    }),
    domain: PropTypes.string,
};

PersonPage.propTypes = propTypes;

export default PersonPage;
